import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Page,
    // Layout,
    Card,
    Badge,
    Icon,
    Button,
    // Tooltip,
    Text,
    Link,
    Banner,
    Modal,
    Popover,
    ActionList,
    BlockStack,
} from '@shopify/polaris';
import { reqGetJsonLdDataV2, reqSaveSwitchState, reqUpSwitchJsonLdSwitchV2 } from '../../../../api';
import './index.css';
import { ArrowRightMinor, CancelMinor, MobileHorizontalDotsMajor } from '@shopify/polaris-icons';
import { connect } from 'react-redux'
import { setPageData } from '../../../../redux/actions/getAppPageData';
import Language from '../../../../i18n/Language';
import Switch from "react-switch";
import LogoForms from './components/LogoForms';
import utils from '../../../../utils/utils';

import { cloneDeep } from 'lodash';
import SkeltonLoading from '../../../../components/SkeltonLoading';
import FaqCardBox from '../../../../components/FaqCardBox';
import ViewImage from '../../../../components/ViewImage';
import { setSaveSwitchData } from '../../../../redux/actions/getAppPublicData';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
const t = Language;

class JsonLdIndexV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showToastText: '',
            showToast: false,
            showToastIserror: false,
            durationTime: 5000,

            //页面动作
            loading: false,
            loadingPage: true,
            //测试链接
            richResultsUrl: '',
            //数据
            logo_url: "",
            organization_name: "",
            social_media_data: {},
            local_business_data: {},
            //开关状态
            breadcrumbStatus: false,
            sitelinksStatus: false,
            productStatus: false,
            articleStatus: false,
            localBusinessStatus: false,
            logoStatus: false,
            collectionStatus: false,
            blogStatus: false,
            // 跳转到shopify主题后台进行保存的链接
            clickHereUrl: "",
            // docModal状态
            docModalStatus: false,
            // Banner状态
            showBanner: false,
            StructList: {
                'Breadcrumb': {
                    title: 'Breadcrumb',
                    desc: ["By using JSON-LD Breadcrumb to provide search engines with a clear and concise representation of your website's structure, which can improve your website's visibility in search results."],
                    status: false,
                    opera: ["Run test", "other pages."],
                    outUrl: 'https://search.google.com/test/rich-results/result?url=',
                    hasImg: 1,
                },
                'Site search box': {
                    title: 'Site search box',
                    desc: ["By using JSON-LD Site Search Box to improve the visibility of your site's search results in search engine results pages (SERPs) and make it easier for users to find the content they are looking for on your website."],
                    status: false,
                    opera: ["Run test", "homepage."],
                    outUrl: 'https://search.google.com/test/rich-results/result?url=',
                    hasImg: 1,
                },
                'Product': {
                    title: 'Product',
                    desc: ["By adding rating stars, vote numbers, pricing, stock information, and other relevant details to enhance the shopping experience for potential customers and improve your website's search engine visibility."],
                    status: false,
                    opera: ["Run test", "product pages."],
                    outUrl: 'https://search.google.com/test/rich-results/result?url=',
                    hasImg: 1,
                },
                'Article': {
                    title: 'Article',
                    desc: ["By using JSON-LD markup on your article pages, you can provide search engines with more detailed information about your content, which can help improve your website's visibility and search engine rankings."],
                    status: false,
                    opera: [],
                    hasImg: 1,
                },
                'Collection': {
                    title: 'Collection',
                    desc: ["By using JSON-LD markup on your collection pages, you can help search engines understand the content on your collection pages better. This can help your website rank higher in search engine results pages (SERPs) and make it easier for users to find your products."],
                    status: false,
                    opera: [],
                    hasImg: 0,
                },
                'Blog': {
                    title: 'Blog',
                    desc: ["By using JSON-LD markup on your blog pages, you can help search engines better understand the content on your page, which can improve your visibility in search results."],
                    status: false,
                    opera: [],
                    hasImg: 0,
                }
            },
            // 对比字段
            compareSwitch: {
                'Breadcrumb': 'breadcrumbStatus',
                'Site search box': 'sitelinksStatus',
                'Product': 'productStatus',
                'Article': 'articleStatus',
                'Collection': 'collectionStatus',
                'Blog': 'blogStatus',
                'Organization': 'logoStatus'
            },
            loadingText: {}, // loading按钮
            loadingSwitch: false, // 开关状态
            runTestObj: {},
            loadingDisBtn: true, // 缓存按钮状态

            questionList: {
                // w_JSON: {
                //     title: "What is JSON-LD?",
                //     tag: ["JSON-LD is a format for embedding structured data on web pages. It utilizes the JSON format to represent data and provides semantic information through Linked Data."]
                // },
                // h_JSON: {
                //     title: "How to enable JSON-LD?",
                //     tag: ["After activating the SEOAnt extension, toggle the switch mentioned above simultaneously. The SEOAnt system will automatically handle it for you. Additionally, you need to fill in some website information."]
                // },
                // wp_JSON: {
                //     title: "What is the purpose of JSON-LD?",
                //     tag: ["JSON-LD makes it easier for search engines to understand and interpret webpage content, thus improving the webpage's ranking in search results and providing users with richer search results."]
                // },
                // hd_JSON: {
                //     title: "How to validate the effectiveness of JSON-LD?",
                //     tag: ["Various online tools or browser extensions can be used to validate the syntax and structure of JSON-LD data to ensure it can be correctly parsed and understood by search engines. The URL for the tool is https://search.google.com/test/rich-results"]
                // },
                // wt_JSON: {
                //     title: "What types of data can JSON-LD represent?",
                //     tag: ["JSON-LD can represent various types of data, including but not limited to organizational information, event information, product information, article information, etc."]
                // },
                // his_JSON: {
                //     title: "How does JSON-LD interact with search engines?",
                //     tag: ["Search engines parse JSON-LD data in web pages and utilize this data to understand the content and structure of the webpage, thereby improving the webpage's ranking in search results and generating richer search results."]
                // },
                // can_JSON: {
                //     title: "Can JSON-LD be used on all types of web pages?",
                //     tag: ["Yes, SEOAnt uses JSON-LD on almost all types of web pages to provide structured data, including articles, product pages, article pages, homepages, etc."]
                // },
                w_jsonld: {
                    title: "What is Google structured data ?",
                    tag: ["Google structured data(JSON-LD) is a format for embedding structured data on web pages. It utilizes the JSON format to represent data and provides semantic information through Linked Data."]
                },
                p_jsonld: {
                    title: "What is the purpose of Google structured data?",
                    tag: ["JSON-LD makes it easier for search engines to understand and interpret webpage content, thus improving the webpage's ranking in search results and providing users with richer search results."]
                },
                h_jsonld: {
                    title: "How to validate the effectiveness of JSON-LD?",
                    tag: ["Various online tools or browser extensions can be used to validate the syntax and structure of JSON-LD data to ensure it can be correctly parsed and understood by search engines. The URL for the tool is"],
                    url: "https://search.google.com/test/rich-results.",
                }
            },
            imgUrl: '',
            level: 1,
            adverShowMore: false,
            isShowCpAppBanner: false,
            originData: {},
        }
    }

    componentDidMount() {
        let _store = this.props.public;
        // 获取开关缓存
        let switchData = _store.publicInit.head_data?.switch_data;
        this.setState({
            level: _store.level,
            isShowCpAppBanner: typeof switchData === 'boolean' ? true : !Boolean(switchData?.jsonld_cp_banner)
        }, () => {
            let _page = this.props.page;
            if (Boolean(_page.pageInit['jsonLD'].ack)) {
                this.getSwitchStatus(_page.pageInit['jsonLD']);
            }
            this.getSwitchStatus();
        })
    }

    /**
     * 获取开关状态
     */
    getSwitchStatus = (data) => {
        let response = '';
        this.setState({
            loading: true,
            loadingDisBtn: true,
        }, async () => {
            if (data) {
                response = data;
            } else {
                response = await reqGetJsonLdDataV2();
            }

            if (response.ack === 1) {
                // 判断是否第一次 第一次则缓存
                this.props.getPageDataRedux(response);
                let resData = response.data

                let structData = cloneDeep(this.state.StructList);
                structData['Breadcrumb']['status'] = Boolean(resData.breadcrumb_list_switch);
                structData['Site search box']['status'] = Boolean(resData.search_switch);
                structData['Product']['status'] = Boolean(resData.product_switch);
                structData['Article']['status'] = Boolean(resData.article_switch);
                structData['Collection']['status'] = Boolean(resData.collection_switch);
                structData['Blog']['status'] = Boolean(resData.blog_switch);

                this.setState({
                    breadcrumbStatus: Boolean(resData.breadcrumb_list_switch),
                    sitelinksStatus: Boolean(resData.search_switch),
                    productStatus: Boolean(resData.product_switch),
                    articleStatus: Boolean(resData.article_switch),
                    localBusinessStatus: Boolean(resData.local_business_switch),
                    logoStatus: Boolean(resData.organization_switch),
                    collectionStatus: Boolean(resData.collection_switch),
                    blogStatus: Boolean(resData.blog_switch),
                    richResultsUrl: resData.domain,
                    logo_url: resData.logo_url,
                    organization_name: resData.organization_name,
                    social_media_data: resData.social_media_data,
                    local_business_data: resData.local_business_data,
                    loading: false,
                    loadingPage: false,
                    StructList: structData,
                    runTestObj: resData.run_test,
                    originData: {
                        organization_name: resData.organization_name,
                        social_media_data: resData.social_media_data,
                        logo_url: resData.logo_url,
                    },
                })
            } else {
                this.props.toggleToast(response.msg, true)
            }

            if (!Boolean(data)) {
                this.setState({
                    loadingDisBtn: false,
                })
            }

        })
    }

    // org开关
    switchOragnizeState = (name) => {
        this.setState({
            logoStatus: !this.state.logoStatus,
            loadingSwitch: true,
        }, () => {
            let params = {
                action: 'organization_switch',
                value: Number(this.state.logoStatus)
            };
            this.updateSwitchStatus(params).then((result) => {
                if (!result) {
                    this.setState({
                        logoStatus: !this.state.logoStatus
                    })
                }
            })
        })
    }

    //子组件传过来的值
    logoInputChangeValue = (name, value) => {
        if (name === "organization_name") {
            this.setState({
                organization_name: value
            });
        } else {
            let data = cloneDeep(this.state.social_media_data);
            data[name] = value;
            this.setState({
                social_media_data: data
            });
        }
        return;
    }

    // business hours 开关按钮
    handleCheckChange = (name) => {
        let { level, compareSwitch, StructList, loadingText } = this.state;
        const state = this.state;
        if (level === 1 && !state[compareSwitch[name]]) {
            this.props.show()
        } else {
            let textList = cloneDeep(loadingText);
            textList[name] = true;
            let params = {};
            let curList = cloneDeep(StructList)
            curList[name]['status'] = !StructList[name]['status'];
            const compareField = {
                'Breadcrumb': 'breadcrumb_list_switch',
                'Site search box': 'search_switch',
                'Product': 'product_switch',
                'Article': 'article_switch',
                'Collection': 'collection_switch',
                'Blog': 'blog_switch',
                'Organization': 'organization_switch'
            }
            //先切换开关状态
            this.setState({
                [compareSwitch[name]]: !state[compareSwitch[name]],
                StructList: curList,
                loadingText: textList
            }, () => {
                params = {
                    action: compareField[name],
                    value: Number(!state[compareSwitch[name]])
                };
                this.updateSwitchStatus(params, name).then((result) => {
                    if (!result) {
                        let curListRes = cloneDeep(curList)
                        curListRes[name]['status'] = !curList[name]['status'];
                        this.setState({
                            [compareSwitch[name]]: state[compareSwitch[name]],
                            StructList: curListRes,
                        })
                    }
                })
            })
        }
    }

    //更新开关状态
    updateSwitchStatus = async (params, name) => {
        let response = '';
        response = await reqUpSwitchJsonLdSwitchV2(params);

        if (response) {
            let data = cloneDeep(this.state.loadingText);
            data[name] = false;
            this.setState({
                loadingSwitch: false,
                loadingText: data,
            })
        }
        if (response.code === 201) {
            this.props.toggleToast(response.msg, true)
            this.setState({
                showBanner: true,
                clickHereUrl: response.data.url,
            })

            return false
        }
        if (response.code === '1000') {
            this.props.show()

            return false
        }
        if (response.ack === 1) {
            this.props.toggleToast(response.msg, false)
            this.setState({
                showBanner: false,
                clickHereUrl: "",
            })
            return true
        } else {
            this.props.toggleToast(response.msg, true)
            return false
        }
    }

    // 跳转外部url
    jumpOutUrl = (type) => {
        const compare = {
            'Breadcrumb': 'breadcrumb',
            'Site search box': 'search_box',
            'Product': 'product',
        }
        let { runTestObj, richResultsUrl } = this.state;
        if (type === 'none') {
            window.open(`https://search.google.com/test/rich-results/result?url=${richResultsUrl}`)
        } else {
            window.open(`https://search.google.com/test/rich-results/result?url=${runTestObj[compare[type]]}`)
        }
    }

    // 切换docModal弹窗状态
    toggleDocModalActive = (value) => {
        this.setState({
            docModalStatus: !value
        })
    }

    // 返回
    goBack = () => {
        utils.routeJump(this, '/searchAppearance')
    }

    //点击联系客服
    handleContactService = () => {
        try {
            window.Willdesk.show()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 预览图片
    viewImageShow = (url) => {
        this.setState({
            imgUrl: url,
        })
    }

    // 关闭
    closeImageShow = () => {
        this.setState({
            imgUrl: ''
        })
    }

    // 关闭合作banner
    closeCpAppBanner = () => {
        this.setState({
            isShowCpAppBanner: false,
            adverShowMore: false,
        }, () => {
            this.requestStateSet('jsonld_cp_banner')
        })
    }

    // 发送请求
    requestStateSet = async (type) => {
        const params = {
            name: `${type}`,
            st: 0,
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
            this.props.setSwitchData(data);
        } else {
            this.props.toggleToast(t("Try again later"), true)
        }
    }

    // 重置数据
    resetData = () => {
        let { originData } = this.state;
        this.setState({
            organization_name: originData.organization_name,
            social_media_data: originData.social_media_data,
            logo_url: originData.logo_url,
        })
    }

    render() {
        const {
            state: {
                loadingPage,
                StructList,
                logoStatus,
                logo_url,
                organization_name,
                social_media_data,
                loadingText,
                loadingSwitch,
                loadingDisBtn,
                questionList,
                imgUrl,
                // level,
                adverShowMore,
                isShowCpAppBanner,
                originData,

            },

        } = this;

        // 合作app banner
        const CpAppBanner = isShowCpAppBanner && <div className='cp-app-banner' style={{ marginTop: '1rem' }}>
            <Card padding={300}>
                <div className='cp-img'><img src='/extra_app/Trustoo-s.png' alt='' /></div>
                <div className='flex_layout cp-info'>
                    <p className='cp-desc'>Trustoo.io reviews work with Google snippets and Shopping to boost your store's conversions.</p>
                    <Button onClick={() => {
                        window.open("https://share.channelwill.com/app/2166d7d9a651427AQ8")
                    }}>Try it now</Button>
                </div>
                <div className="flex_layout">
                    <Popover
                        active={adverShowMore}
                        activator={<span className="cp-close" onClick={() => {
                            this.setState({
                                adverShowMore: !adverShowMore
                            })
                        }}><Icon source={MobileHorizontalDotsMajor} color='base' /></span>}
                        autofocusTarget="first-node"
                        onClose={() => {
                            this.setState({
                                adverShowMore: false
                            })
                        }}
                    >
                        <ActionList
                            actionRole="menuitem"
                            items={[
                                {
                                    content: t("Dismiss"),
                                    icon: CancelMinor,
                                    onAction: () => this.closeCpAppBanner()
                                }
                            ]}
                        />
                    </Popover>
                </div>
                {/* <span className='cp-close' onClick={this.closeCpAppBanner}><Icon source={CancelMinor} tone='base' /></span> */}
            </Card>
        </div>

        // 横向card列表
        const StructuredCard = Object.keys(StructList).map((item, Sindex) => {
            return <div key={item}>
                <Card>
                    <div className='card_state'>
                        <Text variant="headingMd" as="h2">{t(item)}</Text>
                        <span style={{ marginRight: "auto" }}>
                            {
                                StructList[item].status ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
                            }
                        </span>
                        <div className='flex_layout'>
                            {(loadingText[item] || loadingDisBtn) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                            <Switch disabled={loadingText[item] || loadingDisBtn} onChange={() => this.handleCheckChange(item)} checked={StructList[item].status} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                        </div>
                    </div>
                    <div className='card_main'>
                        <div className='card_left'>
                            <p>
                                {t(StructList[item]['desc'][0])}
                                <span>
                                    {
                                        StructList[item]['opera'].map((tag, index) => {
                                            return <span onClick={() => this.jumpOutUrl(StructList[item].title)} key={tag + index} className={tag === 'Run test' ? 'run_test_opera' : ''}>
                                                {t(tag)}
                                            </span>
                                        })
                                    }
                                </span>
                            </p>
                            {/* <div className='card_left_opera'>
                                <Button loading={loadingText[item] || loadingDisBtn} onClick={() => this.handleCheckChange(item)} variant={!StructList[item].status && "primary"}>{!StructList[item].status ? t("Turn on") : t("Turn off")}</Button>
                                <span>
                                    {
                                        StructList[item]['opera'].map((tag, index) => {
                                            return <span onClick={() => this.jumpOutUrl(StructList[item].title)} key={tag + index} className={tag === 'Run test' ? 'run_test_opera' : ''}>
                                                {t(tag)}
                                            </span>
                                        })
                                    }
                                </span>
                            </div> */}
                        </div>
                        {
                            Boolean(StructList[item].hasImg) && <div className='card_right'>
                                <img onClick={() => this.viewImageShow(`/imgJsonLD/${item}_img.png`)} className='zoom-in' src={`/imgJsonLD/${item}_img.png`} alt={item} />
                            </div>
                        }
                    </div>
                </Card>
                {Sindex === 2 && CpAppBanner}
            </div>
        })

        // 组织模块
        const OrganizationCard = <Card>
            <div className='card_state'>
                <Text variant="headingMd" as="h2">{t("Organization")}</Text>
                {
                    logoStatus ? <Badge tone='success'>{t("On")}</Badge> : <Badge>{t("Off")}</Badge>
                }
                <div className='org_switch'>
                    {(loadingSwitch || loadingDisBtn) && <img className="Loading" src="/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                    <Switch disabled={loadingSwitch || loadingDisBtn} onChange={() => this.switchOragnizeState('Organization')} checked={logoStatus} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                </div>
            </div>
            <div className='card_main'>
                <div className='card_left'>
                    <p>{t("The type of store that will show organization information in Google search results after setting up JSON-LD for organization depends on various factors, such as the relevance and quality of the information provided, the search query, and the user's location.")}</p>
                    <div className='card_layout'>
                        <div className='card_left_opera'>
                            <LogoForms
                                show={this.props.show}
                                logo_url={logo_url}
                                organization_name={organization_name}
                                social_media_data={social_media_data}
                                originData={originData}
                                resetData={this.resetData}
                                logoInputChangeValue={(name, value) => this.logoInputChangeValue(name, value)}
                            />
                        </div>
                        <div>
                            <img className='org_img zoom-in' onClick={() => this.viewImageShow('/imgJsonLD/orgExample.png')} src='/imgJsonLD/orgExample.png' alt='orgExample' />
                        </div>
                    </div>
                </div>
            </div>
        </Card>

        const titlePages = <div className='title-font-style'>
            {this.state.showBanner ? <div style={{ marginTop: 24 }}>
                <Banner
                    title="Tip"
                    tone="critical"
                    action={{
                        content: t("Contact us"),
                        onAction: this.handleContactService
                    }}
                >
                    <div className='jsonldBannerContent'>
                        <span>{t("Before displaying structured data, please enable the APP embed block,")}&nbsp;<Link url={this.state.clickHereUrl} external={true}>{t("Click here")}</Link>&nbsp;{t("to open it.")}</span>
                        <div onClick={() => this.toggleDocModalActive(false)} className='jsonldBannerSpan'>
                            <span>{t("view doc")}</span>
                            <Icon source={ArrowRightMinor} />
                        </div>
                    </div>
                </Banner>
            </div> : null}
        </div>

        const docModal = <div>
            <Modal
                size='large'
                open={this.state.docModalStatus}
                onClose={this.toggleDocModalActive}
            >
                <Modal.Section>
                    <div style={{ padding: '2rem' }}>
                        <p>Step 1: Click [click here] in the tips column of the Google Structured Data - Snippets page to jump to the shopify online store-APP embeds page</p>
                        <img src="/imgJsonLD/step1.png" className="pcStep1Img" alt="step1.png" />
                        <img src="/imgJsonLD/mstep1.png" className="mobileStep1Img" alt="step1.png" />
                        <p>Step 2: In shopify online store-APP embeds page, You can see Open the APP embeds of SEOAnt JSON-LD by default, just click the save button in the upper right corner, and you can use the structured data display after returning to the page</p>
                        <img src="/imgJsonLD/step2.png" className="pcStep2Img" alt="step2.png" />
                        <img src="/imgJsonLD/mstep2.png" className="mobileStep2Img" alt="step2.png" />
                    </div>
                </Modal.Section>
            </Modal>
        </div>

        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} hasImg={"/imgJsonLD/local-business03.png"} />

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 等级
        // const lockIcon = (plan = 1) => {
        //     return <div className='PAY_ICON'>
        //         {plan === 2 ? t("Pro plan unlock") : t("Pre plan unlock")} <Icon source={LockMajor} tone="base" />
        //     </div>
        // }

        // 最终页面
        const pageContent = !loadingPage ? <Page
        // title={<div className='pageLayout' style={{ display: "flex", alignItems: "center" }}>
        //     {t("Google Structured Data - Snippets")}&nbsp;
        //     <Tooltip content={t("Effortlessly create structured data(JSON-LD) for different pages, helping search engines understand and rank your pages accurately. Additionally, your pages will have bigger chances to stand out in the SERPs for higher CTRs.")}>
        //         {<Icon backdrop source={QuestionMarkInverseMajor} />}
        //     </Tooltip>
        //     {(level === 1 && false) && lockIcon(2)}
        // </div>}
        // backAction={{
        //     content: t("Feedback"), 
        //     onAction: this.goBack,
        // }}
        >
            <title>Google Structured Data - Snippets</title>

            {/* <div className='correctly_tip'>
                {t("To ensure that the JSON-LD is working correctly, you can")}&nbsp;
                <span onClick={() => this.jumpOutUrl('none')}>{t("use the Google Rich Results Test to validate it.")}</span>
            </div> */}

            {titlePages}
            {docModal}
            <div className='jsonid_card_list'>
                <BlockStack gap={400}>
                    {StructuredCard}
                    {OrganizationCard}
                    {FrequentlyItems}
                </BlockStack>
            </div>
            {FooterHelpBox}
        </Page> : <SkeltonLoading />

        return <div>
            {pageContent}
            {
                Boolean(imgUrl) && <ViewImage imgUrl={imgUrl} closeImageShow={this.closeImageShow} />
            }
        </div>;
    }
}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['jsonLD', data]));
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },
})

JsonLdIndexV2 = connect(
    mapStateToProps,
    mapDispatchToProps
)(JsonLdIndexV2);

export default withRouter(JsonLdIndexV2);